const film=document.getElementById('mosaic-film');
const mobileLayout=matchMedia('(max-width:749px)');
let inView=false, readyToLoad=false;
const mediaUrl=()=>mobileLayout.matches?film.dataset.mobile:film.dataset.desktop;
const syncPlayback=()=>{
  if(!readyToLoad||!inView||document.hidden){film.pause();return}
  const url=mediaUrl();
  if(film.getAttribute('src')!==url){film.classList.remove('has-frame');film.muted=true;film.defaultMuted=true;film.src=url;film.load()}
  film.play().catch(error=>{film.dataset.playbackError=error.name});
};
const showFrame=()=>{if('requestVideoFrameCallback' in film)film.requestVideoFrameCallback(()=>film.classList.add('has-frame'));else film.classList.add('has-frame')};
film.addEventListener('playing',()=>{delete film.dataset.playbackError;showFrame()});
film.addEventListener('error',()=>film.classList.remove('has-frame'));
mobileLayout.addEventListener('change',syncPlayback);
new IntersectionObserver(entries=>{inView=entries[0].isIntersecting;syncPlayback()},{threshold:.05}).observe(film);
film.addEventListener('canplay',syncPlayback);
document.addEventListener('visibilitychange',syncPlayback);
const enableVideo=()=>{readyToLoad=!matchMedia('(prefers-reduced-motion:reduce)').matches&&!navigator.connection?.saveData;syncPlayback()};
document.querySelector('.mosaic-poster img').decode().catch(()=>{}).then(()=>requestAnimationFrame(()=>requestAnimationFrame(()=>{if('requestIdleCallback' in window)requestIdleCallback(enableVideo,{timeout:1200});else setTimeout(enableVideo,200)})));
